module.exports = __webpack_public_path__ + "img/staff.a3337bc2.png";